// eslint-disable-next-line no-shadow
enum PrinterType {
  MACHINE,
  BLUETOOTH,
  SERIAL,
  WHATSAPP,
}
export default PrinterType;
